import { WisecureApiClient, OpenAPI } from './index';

export interface WisecureClientOptions {
  baseUrl?: string;
  token?: string | (() => Promise<string>);
}

export function createWisecureClient(options: WisecureClientOptions = {}): WisecureApiClient {
  return new WisecureApiClient({
    BASE: options.baseUrl ?? '',
    TOKEN: options.token,
    WITH_CREDENTIALS: true,
  });
}

export function configureOpenAPI(options: WisecureClientOptions): void {
  OpenAPI.BASE = options.baseUrl ?? '';
  if (options.token) {
    OpenAPI.TOKEN = options.token;
  }
}
